/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    export class MeevoRangeSelection implements angular.IDirective {
        restrict = "E";
        require = "ngModel";
        scope = {
            specifiedRange: "=", //array of values for button labels
            contentKey: "@",
            selectedAmount: '=ngModel',
            actionKey: "@?",   //LABEL of button in input field
            useBalance: "&?",
            addPayment: "&",
            hideAdd: "@?",
            hideReset: "@?",
            addKey: "@",
            addMode: "=?",
            changed: "&?ngChange"
        };

        templateUrl = "app/components/controls/rangeSelectionTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, formCtrl: angular.IFormController) => {
            
            /*scope.elementHeight = null;
            window.setTimeout(function () {
                scope.elementHeight = angular.element('#range-selection button').css('width');
                scope.$apply();

            })*/
            scope.addMode = scope.addMode == undefined ? true : scope.addMode;
            scope.addAmount = function (amount) {
                if (scope.addMode) {
                    scope.selectedAmount = scope.selectedAmount + amount;
                } else {
                    scope.selectedAmount = amount;
                }
                scope.changedLocal();
            }

            scope.changedLocal = ()=> {
                if (angular.isFunction(scope.changed)) {
                    this.$timeout(function () {
                        scope.changed();
                    });
                };
            }
            scope.reset = function() {
                scope.selectedAmount = 0;
                scope.changedLocal();
            }

            if (!scope.addKey) {
                scope.addKey = "LABEL_ADD_PAYMENT";
            }
        }

        constructor(private $timeout: angular.ITimeoutService) { }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout: angular.ITimeoutService) => {
                return new MeevoRangeSelection($timeout);
            };
            directive.$inject = [
                '$timeout'
            ];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoRangeSelection", MeevoRangeSelection.factory());
}
